import { httpClient } from "../../httpClient";
import { AccessAdminGroupRole } from "@api/types/accessadmin";

const accesAdminWebApi = "/api/v1/accessadmin/";

type Data = any;

export async function getUserGroups(): Promise<any> {
  try {
    const { data } = await httpClient.get(`${accesAdminWebApi}usergroups`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getGroupRolesByUserGroupId(id: number): Promise<any> {
  try {
    if (id) {
      const { data } = await httpClient.get(
        `${accesAdminWebApi}grouproles/${id}`
      );
      return data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postGroupRole(
  payload: AccessAdminGroupRole
): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(
      `${accesAdminWebApi}grouproles`,
      payload
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function deleteGroupRoleById(id: number): Promise<any> {
  try {
    if (id) {
      const { data } = await httpClient.get<boolean>(
        `${accesAdminWebApi}grouproles/delete/${id}`
      );
      return data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const accessadmin = {
  getUserGroups,
  getGroupRolesByUserGroupId,
  postGroupRole,
  deleteGroupRoleById,
};
